import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:opacity-70 group-[.toast]:text-sm",
        },
        style: {
          "--normal-bg": "var(--c-elevated-1)",
          "--normal-text": "var(--c-text)",
          "--normal-border": "var(--c-divider)",
        } as React.CSSProperties,
      }}
      {...props}
    />
  );
};

export { Toaster };
